/* SmartSource Mail-In Repair: price calculator + request form.
   Calculator (one view): panel with device, brand, model, repair, part quality; a live result card (sticky on desktop,
   bottom bar on mobile). "Request this repair" opens Details -> Review, which post to the Shopify contact form (/contact).
   SIMPLE repairs (screen, battery, port, back glass, camera) are priced from #mir-data (snippets/mir-data.liquid:
   products of type "Mail-in Repair", variant metafields in namespace "repair"). A price shows only when Pricing Live
   is on and the row is not a placeholder; otherwise "Price confirmed after inspection".
   COMPLEX repairs (data / photo recovery, water damage, won't turn on, board / CPU) have no instant price: the
   diagnostic fee (section setting, data-diag-fee) + "No fix, no fee", and extra questions on the Details step.
   The customer covers shipping and waits for our approval email before mailing the device. */
(function () {
  'use strict';

  /* ---------- Analytics ---------- */
  function track(name, data) {
    data = data || {};
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: 'mir_' + name }, data)); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('mir_' + name, data); } catch (e) {}
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-mir-track]');
    if (t) track('click', { target: t.getAttribute('data-mir-track') });
  });

  var app = document.querySelector('[data-mir-app]');
  if (!app) return;
  var D = { models: [], live: false, tiers: [], bundle: 0, validDays: 14, shipFee: 0 };
  var dataEl = document.getElementById('mir-data');
  if (dataEl) { try { D = Object.assign(D, JSON.parse(dataEl.textContent)); } catch (e) {} }

  /* ---------- Helpers ---------- */
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var money = function (cents) { var n = Math.round(cents) / 100; return '$' + (n % 1 ? n.toFixed(2) : String(n)); };
  var money2 = function (cents) { return '$' + (Math.round(cents) / 100).toFixed(2); };
  var uniq = function (a) { return a.filter(function (x, i) { return x != null && x !== '' && a.indexOf(x) === i; }); };
  var CHECK = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  var svg = function (p) { return '<svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + p + '</svg>'; };
  var ICON = {
    phone: svg('<rect x="6.5" y="2.5" width="11" height="19" rx="2.5"/><path d="M10.5 18.5h3"/>'),
    tablet: svg('<rect x="4" y="2.5" width="16" height="19" rx="2.5"/><path d="M10.5 18.5h3"/>'),
    laptop: svg('<rect x="4.5" y="5" width="15" height="10.5" rx="1.5"/><path d="M2.5 19h19"/>'),
    console: svg('<path d="M7 8h10a4 4 0 0 1 4 4v1.5a3 3 0 0 1-5.4 1.8L14.5 14h-5l-1.1 1.3A3 3 0 0 1 3 13.5V12a4 4 0 0 1 4-4z"/><path d="M8 10.5v3M6.5 12h3"/><circle cx="15.5" cy="11.5" r=".6" fill="currentColor"/><circle cx="17" cy="13" r=".6" fill="currentColor"/>'),
    other: svg('<circle cx="12" cy="12" r="9"/><path d="M9.6 9.3a2.5 2.5 0 0 1 4.8 1c0 1.7-2.4 2.1-2.4 3.7"/><circle cx="12" cy="17.2" r=".6" fill="currentColor"/>'),
    search: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="6.5"/><path d="M16 16l4 4"/></svg>'
  };

  var DIAG_FEE = Math.round(Number(app.getAttribute('data-diag-fee') || 0) * 100);
  var TIER_ORDER = (D.tiers || []).map(function (t) { return t.key; });
  var tierName = function (key) { for (var i = 0; i < (D.tiers || []).length; i++) if (D.tiers[i].key === key) return D.tiers[i].name || key; return key; };
  var realCopy = function (s) { return s && !/^\s*PLACEHOLDER/i.test(s) ? s : ''; };

  var models = (D.models || []).filter(function (m) { return !m.diag; });
  var diag = (D.models || []).filter(function (m) { return m.diag; })[0] || null;
  var modelBy = function (h) { for (var i = 0; i < models.length; i++) if (models[i].handle === h) return models[i]; return null; };

  ICON.reset = '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3.5 12a8.5 8.5 0 1 0 2.6-6.1"/><path d="M3.5 4v4.5H8"/></svg>';
  ICON.clock = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/></svg>';
  ICON.shield = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l7 3v5.5c0 4.3-3 7.9-7 9-4-1.1-7-4.7-7-9V6l7-3z"/><path d="M9 12l2 2 4-4"/></svg>';
  ICON.mail = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3.5" y="5.5" width="17" height="13" rx="2"/><path d="M4 7l8 6 8-6"/></svg>';

  /* ---------- Catalogue ---------- */
  var DEVICES = [['phone', 'Phone'], ['tablet', 'Tablet'], ['laptop', 'Laptop'], ['console', 'Console']];
  var DEFAULT_BRANDS = { phone: ['Apple', 'Samsung', 'Google'], tablet: ['Apple', 'Samsung'], laptop: ['Apple'], console: [] };
  var catOf = function (m) { return m.category || 'phone'; };
  function brandsFor(dev) {
    if (!dev) return [];
    var fromData = uniq(models.filter(function (m) { return catOf(m) === dev; }).map(function (m) { return m.brand; }));
    return uniq((DEFAULT_BRANDS[dev] || []).concat(fromData)).concat(['Other']);
  }
  function modelsFor(dev, brand) { return models.filter(function (m) { return catOf(m) === dev && m.brand === brand; }); }

  var STD_LABEL = { 'Screen': 'Screen', 'Battery': 'Battery', 'Charging port': 'Charging port', 'Back glass': 'Back glass', 'Rear camera': 'Camera' };
  var STD_ORDER = ['Screen', 'Battery', 'Charging port', 'Back glass', 'Rear camera'];
  var COMPLEX = [['Water damage', 'Water damage'], ['No power', "Won't turn on"], ['Data recovery', 'Data recovery'], ['Photo recovery', 'Photo recovery'], ['Motherboard / micro-soldering', 'Board / CPU repair']];
  var COMPLEX_KEYS = COMPLEX.map(function (c) { return c[0]; });
  var OTHER = '__other';
  var isComplex = function (p) { return COMPLEX_KEYS.indexOf(p) > -1; };

  /* ---------- State (sessionStorage) ---------- */
  var KEY = 'mir-calc-v1';
  var fresh = function () { return { view: 'calc', dev: null, brand: null, model: null, manual: false, typed: '', spec: null, probs: [], tier: null, otherText: '', details: {} }; };
  var store = {
    get: function (k) { try { return JSON.parse(sessionStorage.getItem(k) || 'null'); } catch (e) { return null; } },
    set: function (k, v) { try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {} },
    del: function (k) { try { sessionStorage.removeItem(k); } catch (e) {} }
  };
  var S = Object.assign(fresh(), store.get(KEY) || {});
  if (['calc', 'details', 'review'].indexOf(S.view) < 0) S.view = 'calc';
  var save = function () { store.set(KEY, S); };

  var presetModel = app.getAttribute('data-preset-model');
  var presetService = app.getAttribute('data-preset-service');
  if (presetModel && modelBy(presetModel) && S.model !== presetModel) {
    var pm = modelBy(presetModel);
    S = fresh(); S.dev = catOf(pm); S.brand = pm.brand; S.model = pm.handle;
  }
  if (presetService && isComplex(presetService) && !S.probs.length) S.probs = [presetService];

  /* ---------- Data lookups ---------- */
  function specsOf(m) { return m ? uniq(m.variants.map(function (v) { return v.spec; })) : []; }
  function variantsFor(m) { return m.variants.filter(function (v) { return !S.spec || !v.spec || v.spec === S.spec; }); }
  function tierOptions(m, issue) {
    if (!m) return [];
    return variantsFor(m).filter(function (v) { return v.issue === issue && (v.stock || v.oos === 'show'); })
      .sort(function (a, b) { return TIER_ORDER.indexOf(a.tier) - TIER_ORDER.indexOf(b.tier); });
  }
  var priced = function (v) { return !!(v && D.live && !v.ph && v.price > 0); };
  function stdIssues() {
    var m = modelBy(S.model);
    var src = m ? variantsFor(m) : [].concat.apply([], models.map(function (x) { return x.variants; }));
    var list = uniq(src.map(function (v) { return v.issue; })).filter(function (i) { return !isComplex(i); });
    if (!list.length) list = STD_ORDER.slice();
    return list.sort(function (a, b) { var ia = STD_ORDER.indexOf(a), ib = STD_ORDER.indexOf(b); return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib); });
  }
  var probLabel = function (p) {
    if (p === OTHER) return 'Other';
    for (var i = 0; i < COMPLEX.length; i++) if (COMPLEX[i][0] === p) return COMPLEX[i][1];
    return STD_LABEL[p] || p;
  };
  var hasComplex = function () { return S.probs.some(isComplex); };
  function deviceName() {
    var m = modelBy(S.model);
    if (m) return m.title + (S.spec ? ' (' + S.spec + ')' : '');
    var t = String(S.typed || '').trim();
    if (t) return t;
    var dl = S.dev ? DEVICES.filter(function (d) { return d[0] === S.dev; })[0][1] : '';
    return S.brand && S.brand !== 'Other' ? S.brand + ' ' + dl.toLowerCase() : dl;
  }
  function hasModel() { return !!(modelBy(S.model) || String(S.typed || '').trim().length > 1); }

  /* Part quality: tiers offered for the selected simple repairs on this model. */
  function tierChoices() {
    var m = modelBy(S.model); if (!m) return [];
    var keys = [];
    S.probs.filter(function (p) { return !isComplex(p) && p !== OTHER; }).forEach(function (p) {
      tierOptions(m, p).forEach(function (v) { if (v.tier && keys.indexOf(v.tier) < 0) keys.push(v.tier); });
    });
    return keys.sort(function (a, b) { return TIER_ORDER.indexOf(a) - TIER_ORDER.indexOf(b); });
  }
  function tierInfo(key) { for (var i = 0; i < (D.tiers || []).length; i++) if (D.tiers[i].key === key) return D.tiers[i]; return { key: key, name: key, desc: '', ph: true }; }
  function chosenTier() {
    var keys = tierChoices(); if (!keys.length) return null;
    if (S.tier && keys.indexOf(S.tier) > -1) return S.tier;
    var m = modelBy(S.model); var rec = null;
    S.probs.forEach(function (p) { tierOptions(m, p).forEach(function (v) { if (!rec && v.rec) rec = v.tier; }); });
    return rec && keys.indexOf(rec) > -1 ? rec : keys[0];
  }

  /* Quote: simple lines (priced or not), complex lines (diagnosis first), other. */
  function computeQuote() {
    var m = modelBy(S.model); var lines = []; var tier = chosenTier();
    S.probs.forEach(function (p) {
      if (p === OTHER) { lines.push({ key: p, label: 'Other', kind: 'other', note: S.otherText }); return; }
      if (isComplex(p)) { lines.push({ key: p, label: probLabel(p), kind: 'complex' }); return; }
      var opts = tierOptions(m, p);
      var v = opts.filter(function (o) { return o.tier === tier; })[0] || opts.filter(function (o) { return o.rec; })[0] || opts[0] || null;
      lines.push({ key: p, label: probLabel(p), kind: 'std', v: priced(v) ? v : null, tier: v ? v.tier : null });
    });
    var simple = lines.filter(function (l) { return l.kind !== 'complex'; });
    var pricedLines = lines.filter(function (l) { return l.v; });
    var sub = pricedLines.reduce(function (s, l) { return s + l.v.price; }, 0);
    var disc = pricedLines.length > 1 && D.bundle > 0 ? Math.round(sub * D.bundle / 100) : 0;
    var days = pricedLines.reduce(function (d, l) { return Math.max(d, (l.v.days || 0) + (l.v.stock ? 0 : (l.v.oosDays || 0))); }, 0);
    var warr = pricedLines.reduce(function (w, l) { return l.v.warranty ? (w ? Math.min(w, l.v.warranty) : l.v.warranty) : w; }, 0);
    return { lines: lines, simple: simple.length, complex: lines.length - simple.length, priced: pricedLines.length,
      allPriced: simple.length > 0 && pricedLines.length === simple.length, sub: sub, disc: disc, total: sub - disc, days: days, warrantyMonths: warr ? Math.round(warr / 30) : 0, tier: tier };
  }

  /* ---------- Elements ---------- */
  var calcView = $('[data-mir-calcview]', app);
  var panel = $('[data-mir-panel]', app);
  var result = $('[data-mir-result]', app);
  var mbar = $('[data-mir-mbar]', app);
  var formcard = $('[data-mir-formcard]', app);
  var detailsEl = $('[data-mir-details]', app);
  var reviewEl = $('[data-mir-review]', app);
  var form = $('[data-mir-form]', app);
  var postedEl = $('[data-mir-posted]', app);

  /* ---------- Panel ---------- */
  function tile(act, val, label, on, extra) {
    return '<button type="button" class="mir-opt' + (on ? ' is-on' : '') + '" aria-pressed="' + (on ? 'true' : 'false') + '" data-act="' + act + '" data-v="' + esc(val) + '"' + (extra || '') + '>' + esc(label) + '</button>';
  }
  function group(n, label, inner, id) { return '<div class="mir-grp"' + (id ? ' id="' + id + '"' : '') + '><p class="mir-grp__l"><span>' + n + '</span> · ' + label + '</p>' + inner + '</div>'; }

  function panelHtml() {
    var html = '';
    html += group(1, 'Device', '<div class="mir-opts mir-opts--4" role="group" aria-label="Device">' + DEVICES.map(function (d) { return tile('dev', d[0], d[1], S.dev === d[0]); }).join('') + '</div>', 'mir-g-dev');
    if (S.dev) {
      html += group(2, 'Brand', '<div class="mir-opts' + (brandsFor(S.dev).length === 4 ? ' mir-opts--4' : '') + '" role="group" aria-label="Brand">' + brandsFor(S.dev).map(function (b) { return tile('brand', b, b, S.brand === b); }).join('') + '</div>', 'mir-g-brand');
    }
    if (S.dev && S.brand) {
      var list = S.brand === 'Other' ? [] : modelsFor(S.dev, S.brand);
      var inner;
      if (list.length && !S.manual) {
        inner = '<label class="mir-select"><span class="visually-hidden">Model</span><select data-mir-model><option value="">Choose your model</option>' +
          list.map(function (m) { return '<option value="' + esc(m.handle) + '"' + (S.model === m.handle ? ' selected' : '') + '>' + esc(m.title) + '</option>'; }).join('') +
          '<option value="__manual">My model isn\'t listed</option></select></label>';
        var specs = specsOf(modelBy(S.model));
        if (specs.length) inner += '<div class="mir-opts mir-opts--sm" role="group" aria-label="Version">' + specs.map(function (sp) { return tile('spec', sp, sp, S.spec === sp); }).join('') + '</div>';
      } else {
        inner = '<label class="mir-input"><span class="visually-hidden">Brand and model</span><input type="text" data-mir-typed autocomplete="off" placeholder="Type your brand and model, e.g. Pixel 8 Pro" value="' + esc(S.typed) + '"></label>' +
          (list.length ? '<button type="button" class="mir-textbtn" data-act="listmode">Choose from the list</button>' : '');
      }
      html += group(3, 'Model', inner, 'mir-g-model');
    }
    if (S.dev && S.brand && hasModel()) {
      var simple = stdIssues();
      var r = '<div class="mir-opts" role="group" aria-label="Repair">' + simple.map(function (p) { return tile('prob', p, probLabel(p), S.probs.indexOf(p) > -1); }).join('') + '</div>' +
        '<p class="mir-sub-l">Complex repairs <span>· ' + (DIAG_FEE ? money(DIAG_FEE) + ' diagnostic' : 'diagnosis first') + '</span></p>' +
        '<div class="mir-opts" role="group" aria-label="Complex repairs">' + COMPLEX.map(function (c) { return tile('prob', c[0], c[1], S.probs.indexOf(c[0]) > -1); }).join('') + tile('prob', OTHER, 'Other', S.probs.indexOf(OTHER) > -1) + '</div>' +
        (S.probs.indexOf(OTHER) > -1 ? '<label class="mir-input mir-input--area"><span class="visually-hidden">What\'s going on?</span><textarea rows="3" data-mir-other placeholder="Tell us what\'s going on">' + esc(S.otherText) + '</textarea></label>' : '');
      html += group(4, 'Repair <small>(pick all that apply)</small>', r, 'mir-g-repair');
      var keys = tierChoices();
      if (keys.length) {
        var cur = chosenTier(); var m = modelBy(S.model);
        html += group(5, 'Part quality', '<div class="mir-seg" role="radiogroup" aria-label="Part quality">' + keys.map(function (k) {
          var t = tierInfo(k); var on = k === cur;
          var subl = !t.ph && realCopy(t.desc) ? t.desc : '';
          if (!subl) {
            var w = 0; S.probs.forEach(function (p) { tierOptions(m, p).forEach(function (v) { if (v.tier === k && priced(v) && v.warranty) w = w ? Math.min(w, v.warranty) : v.warranty; }); });
            subl = w ? Math.round(w / 30) + '-month warranty' : '';
          }
          return '<button type="button" role="radio" aria-checked="' + on + '" class="mir-seg__b' + (on ? ' is-on' : '') + '" data-act="tier" data-v="' + esc(k) + '"><span class="mir-seg__t">' + esc(t.name || k) + '</span>' + (subl ? '<span class="mir-seg__s">' + esc(subl) + '</span>' : '') + '</button>';
        }).join('') + '</div>', 'mir-g-tier');
      }
    }
    html += '<button type="button" class="mir-reset" data-act="reset">' + ICON.reset + '<span>Start over</span></button>';
    return html;
  }

  /* ---------- Result card ---------- */
  function priceState(q) {
    var fee = DIAG_FEE ? money(DIAG_FEE) : '';
    if (!q.lines.length) return { kind: 'empty' };
    if (!q.simple) return { kind: 'fee', big: fee || 'Diagnosis first', unit: fee ? 'diagnostic fee' : '' };
    if (q.allPriced) return { kind: 'price', big: money2(q.total), extra: q.complex && fee ? '+ ' + fee + ' diagnostic for complex repairs' : '' };
    return { kind: 'tbd', big: 'Price confirmed after inspection', extra: q.complex && fee ? '+ ' + fee + ' diagnostic for complex repairs' : '' };
  }
  function contextLine(q) {
    var bits = [];
    var dn = (S.dev && S.brand && hasModel()) ? deviceName() : '';
    if (dn) bits.push(dn);
    if (q.lines.length) bits.push(q.lines.map(function (l) { return l.label; }).join(', '));
    if (q.tier && q.simple) bits.push(tierInfo(q.tier).name || q.tier);
    return bits.join(' · ');
  }
  function canRequest() { return !!(S.dev && S.brand && hasModel() && S.probs.length); }
  function missingHint() {
    if (!S.dev) return 'Choose your device to start.';
    if (!S.brand) return 'Choose the brand.';
    if (!hasModel()) return 'Choose or type your model.';
    if (!S.probs.length) return 'Pick the repair you need.';
    return '';
  }
  function resultHtml() {
    var q = computeQuote(); var st = priceState(q);
    var ctx = contextLine(q);
    var price;
    if (st.kind === 'empty') price = '<p class="mir-res__big mir-res__big--tbd mir-res__big--muted">Your price shows here</p>';
    else if (st.kind === 'tbd') price = '<p class="mir-res__big mir-res__big--tbd">' + st.big + '</p>';
    else price = '<p class="mir-res__big">' + esc(st.big) + (st.unit ? '<span class="mir-res__unit">' + st.unit + '</span>' : '') + '</p>';
    var breakdown = '';
    if (q.lines.length > 1 || q.disc) {
      breakdown = '<ul class="mir-res__lines">' + q.lines.map(function (l) {
        var r = l.v ? money2(l.v.price) : l.kind === 'complex' ? 'Diagnosis' : 'To confirm';
        return '<li><span>' + esc(l.label) + '</span><span' + (l.v ? '' : ' class="is-tbd"') + '>' + r + '</span></li>';
      }).join('') + (q.disc ? '<li class="is-disc"><span>Bundle discount (' + D.bundle + '%)</span><span>&minus;' + money2(q.disc) + '</span></li>' : '') + '</ul>';
    }
    var notes = [];
    if (st.extra) notes.push('<p class="mir-res__extra">' + esc(st.extra) + '</p>');
    if (q.complex) notes.push('<p class="mir-res__nofix">Diagnostic fee waived if you approve the repair or we can\'t fix it.</p>');
    var note = st.kind === 'empty' ? 'Pick your device and repair to see your price.' :
      (st.kind === 'price' ? 'Prices in CAD, plus tax. ' : '') + 'Final price confirmed after we inspect your device. You cover shipping both ways.';
    var info = [];
    if (q.days) info.push('<li><span class="mir-res__ic">' + ICON.clock + '</span><span><b>Estimated time on the bench</b>' + q.days + ' business day' + (q.days === 1 ? '' : 's') + '</span></li>');
    if (q.warrantyMonths) info.push('<li><span class="mir-res__ic">' + ICON.shield + '</span><span><b>Warranty</b>' + q.warrantyMonths + ' months</span></li>');
    if (!info.length) info.push('<li><span class="mir-res__ic">' + ICON.mail + '</span><span><b>Wait for our go-ahead</b>We email next steps before you ship your device.</span></li>');
    var ok = canRequest();
    return '<p class="mir-res__ctx">' + (ctx ? esc(ctx) : 'Your repair') + '</p>' + price + notes.join('') + breakdown +
      '<p class="mir-res__note">' + note + '</p>' +
      '<ul class="mir-res__info">' + info.join('') + '</ul>' +
      '<button type="button" class="mir-btn mir-btn--block" data-act="request"' + (ok ? '' : ' aria-disabled="true"') + '>Request this repair</button>' +
      '<p class="mir-res__hint" data-mir-hint>' + (ok ? '' : esc(missingHint())) + '</p>' +
      '<p class="mir-res__help">Questions? <a href="/pages/contact">Contact us</a></p>';
  }
  function mbarHtml() {
    var q = computeQuote(); var st = priceState(q);
    var v = st.kind === 'empty' ? 'Your price' : st.kind === 'tbd' ? 'Price after inspection' : st.big + (st.unit ? ' ' + st.unit : '');
    var s2 = st.kind === 'price' && st.extra ? st.extra : (q.complex ? 'No fix, no fee' : (st.kind === 'empty' ? missingHint() : 'You cover shipping'));
    return '<div class="mir-mbar__p"><b' + (st.kind === 'price' || st.kind === 'fee' ? '' : ' class="is-sm"') + '>' + esc(v) + '</b><small>' + esc(s2) + '</small></div><button type="button" class="mir-btn" data-act="request"' + (canRequest() ? '' : ' aria-disabled="true"') + '>Request this repair</button>';
  }

  /* ---------- Details / review ---------- */
  var answer = function (key) { return S.details['q_' + key] || ''; };
  function answers() {
    var dd = S.details || {}; var out = [];
    var add = function (k, v) { if (v && String(v).trim()) out.push([k, String(v).trim()]); };
    if (hasComplex()) {
      add('Powers on', answer('power'));
      add('Exposed to liquid', answer('liquid'));
      if (answer('liquid') === 'Yes') add('What matters most', dd.priority);
      add('Bent, badly damaged or previously repaired', answer('damaged'));
      add('Needs data recovery', answer('data'));
    }
    add('What happened', dd.what);
    add('Testing access', dd.access);
    add('Preferred contact', answer('contact'));
    return out;
  }
  function contactLines() {
    var dd = S.details || {};
    return [dd.name, dd.email, dd.phone, dd.street, [dd.city, dd.prov].filter(Boolean).join(', ') + (dd.postal ? ' ' + String(dd.postal).toUpperCase() : '')]
      .map(function (x) { return String(x || '').trim(); }).filter(Boolean);
  }
  function quoteSummaryHtml(q) {
    var st = priceState(q);
    return '<ul class="mir-res__lines mir-res__lines--plain">' + q.lines.map(function (l) {
        var r = l.v ? money2(l.v.price) : l.kind === 'complex' ? 'Diagnosis first' : 'To confirm';
        return '<li><span>' + esc(l.label) + (l.v && l.tier ? ' <small>' + esc(tierInfo(l.tier).name || l.tier) + '</small>' : '') + '</span><span' + (l.v ? '' : ' class="is-tbd"') + '>' + r + '</span></li>';
      }).join('') + (q.disc ? '<li class="is-disc"><span>Bundle discount (' + D.bundle + '%)</span><span>&minus;' + money2(q.disc) + '</span></li>' : '') + '</ul>' +
      '<div class="mir-glance__tot"><span>' + (st.kind === 'price' ? 'Repair total <small>CAD, plus tax</small>' : st.kind === 'fee' ? 'Diagnostic fee' : 'Repair price') + '</span><b>' + (st.kind === 'tbd' ? 'Confirmed after inspection' : esc(st.big)) + '</b></div>' +
      (st.extra ? '<p class="mir-glance__x">' + esc(st.extra) + '</p>' : '') +
      (q.complex ? '<p class="mir-glance__x">Diagnostic fee waived if you approve the repair or we can\'t fix it.</p>' : '') +
      '<p class="mir-glance__x">You cover shipping both ways.</p>';
  }
  function reviewHtml() {
    var q = computeQuote();
    var row = function (k, v) { return '<div><dt>' + esc(k) + '</dt><dd>' + esc(v).replace(/\n/g, '<br>') + '</dd></div>'; };
    return '<div class="mir-glance__sec"><div class="mir-glance__h"><span>Device and repair</span><button type="button" class="mir-textbtn" data-act="calc">Edit</button></div>' +
        '<p class="mir-glance__dev">' + esc(deviceName()) + '</p>' + quoteSummaryHtml(q) + '</div>' +
      '<div class="mir-glance__sec"><div class="mir-glance__h"><span>About the device</span><button type="button" class="mir-textbtn" data-act="details">Edit</button></div><dl class="mir-glance__dl">' + answers().map(function (a) { return row(a[0], a[1]); }).join('') + '</dl></div>' +
      '<div class="mir-glance__sec"><div class="mir-glance__h"><span>Contact and return address</span><button type="button" class="mir-textbtn" data-act="details">Edit</button></div><p class="mir-glance__addr">' + contactLines().map(esc).join('<br>') + '</p></div>';
  }
  function setAnswer(fs, val) {
    $$('[data-qv]', fs).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-qv') === val ? 'true' : 'false'); });
    $('[data-qin]', fs).value = val;
    if (val) fs.classList.remove('is-missing');
    if (fs.getAttribute('data-q') === 'liquid') { var box = $('[data-mir-liquid]', app); if (box) box.hidden = val !== 'Yes'; }
  }
  function detailsValid() {
    var st = $('[data-mir-dstatus]', detailsEl); st.textContent = '';
    var qs = $$('[data-q]', detailsEl).filter(function (fs) { return !fs.closest('[hidden]'); });
    var missing = qs.filter(function (fs) { return !$('[data-qin]', fs).value; });
    qs.forEach(function (fs) { fs.classList.toggle('is-missing', missing.indexOf(fs) > -1); });
    if (missing.length) { st.textContent = 'Please answer every question.'; $('[data-qv]', missing[0]).focus(); return false; }
    var bad = $$('[required]', detailsEl).filter(function (f) { return !f.closest('[hidden]') && !f.checkValidity(); })[0];
    if (bad) { bad.reportValidity(); bad.focus(); return false; }
    return true;
  }

  /* ---------- Render ---------- */
  function renderCalc() {
    panel.innerHTML = panelHtml();
    renderResult();
  }
  function renderResult() {
    result.innerHTML = resultHtml();
    if (mbar) mbar.innerHTML = mbarHtml();
    updateBar();
  }
  function render(focus) {
    var inForm = S.view === 'details' || S.view === 'review';
    if (inForm && !detailsEl) S.view = 'calc', inForm = false;
    calcView.hidden = inForm;
    if (formcard) formcard.hidden = !inForm;
    updateBar();
    if (!inForm) { renderCalc(); return; }
    detailsEl.hidden = S.view !== 'details';
    reviewEl.hidden = S.view !== 'review';
    if (S.view === 'details') {
      var c = hasComplex(); var q = computeQuote(); var st = priceState(q);
      var cx = $('[data-mir-complex]', detailsEl); if (cx) cx.hidden = !c;
      var what = $('[data-d="what"]', detailsEl); if (what) what.required = c;
      var wl = $('[data-mir-what-l]', detailsEl); if (wl) wl.innerHTML = c ? 'What happened? Tell us what works and what doesn\'t.' : 'What happened? <small>(optional)</small>';
      var sum = $('[data-mir-sum]', detailsEl);
      if (sum) sum.innerHTML = '<span><b>' + esc(deviceName()) + '</b> · ' + esc(q.lines.map(function (l) { return l.label; }).join(', ')) + '</span><span>' + esc(st.kind === 'tbd' ? 'Price after inspection' : st.big + (st.unit ? ' ' + st.unit : '')) + '</span>';
      $$('[data-d]', detailsEl).forEach(function (f) { var k = f.getAttribute('data-d'); if (S.details[k] != null && !f.value) f.value = S.details[k]; });
      $$('[data-q]', detailsEl).forEach(function (fs) { setAnswer(fs, answer(fs.getAttribute('data-q'))); });
    } else {
      $('[data-mir-glance]', reviewEl).innerHTML = reviewHtml();
    }
    if (focus) {
      var t = $('.mir-step__title', S.view === 'details' ? detailsEl : reviewEl);
      if (t) t.focus({ preventScroll: true });
      var r = app.getBoundingClientRect();
      if (r.top < 0 || r.top > window.innerHeight * 0.5) app.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
  }
  function go(view) { S.view = view; save(); render(true); track('step', { step: view, model: S.model, device: S.dev }); }
  function refocus(sel) { var el = $(sel, panel); if (el) el.focus({ preventScroll: true }); }

  /* Mobile bottom bar: shown on the calculator view while the result card is off screen. */
  var resultVisible = false;
  function updateBar() { if (mbar) mbar.hidden = S.view !== 'calc' || resultVisible || !S.probs.length; }
  if (mbar && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) { resultVisible = en[0].isIntersecting; updateBar(); }, { threshold: 0.15 }).observe(result);
  }

  /* ---------- Events ---------- */
  function request(btn) {
    if (!canRequest()) {
      var hint = $('[data-mir-hint]', result); if (hint) hint.textContent = missingHint();
      var target = !S.dev ? '#mir-g-dev' : !S.brand ? '#mir-g-brand' : !hasModel() ? '#mir-g-model' : '#mir-g-repair';
      var g = $(target, panel); if (g) { g.scrollIntoView({ block: 'center', behavior: 'smooth' }); var f = $('button,select,input', g); if (f) f.focus({ preventScroll: true }); }
      return;
    }
    var q = computeQuote();
    track('request_start', { model: S.model, items: q.lines.map(function (l) { return l.key; }).join(','), priced: q.priced, complex: q.complex });
    go('details');
  }
  app.addEventListener('click', function (e) {
    var qb = e.target.closest('[data-qv]');
    if (qb) {
      var fs = qb.closest('[data-q]'); S.details['q_' + fs.getAttribute('data-q')] = qb.getAttribute('data-qv'); setAnswer(fs, qb.getAttribute('data-qv')); save();
      var ds = $('[data-mir-dstatus]', app); if (ds && !$$('.mir-q.is-missing', app).length) ds.textContent = '';
      return;
    }
    var b = e.target.closest('[data-act]'); if (!b || b.disabled) return;
    var a = b.getAttribute('data-act'), v = b.getAttribute('data-v');
    switch (a) {
      case 'dev':
        if (S.dev !== v) { S.dev = v; S.brand = null; S.model = null; S.spec = null; S.manual = false; S.typed = ''; S.tier = null; S.probs = S.probs.filter(function (p) { return isComplex(p) || p === OTHER; }); }
        save(); renderCalc(); refocus('[data-act="dev"][data-v="' + v + '"]'); track('device', { device: v }); break;
      case 'brand':
        if (S.brand !== v) { S.brand = v; S.model = null; S.spec = null; S.manual = v === 'Other' || !modelsFor(S.dev, v).length; S.typed = ''; S.tier = null; S.probs = S.probs.filter(function (p) { return isComplex(p) || p === OTHER; }); }
        save(); renderCalc();
        if (S.manual) refocus('[data-mir-typed]'); else refocus('[data-mir-model]');
        track('brand', { brand: v }); break;
      case 'spec': S.spec = v; save(); renderCalc(); refocus('[data-act="spec"][data-v="' + v + '"]'); break;
      case 'listmode': S.manual = false; S.typed = ''; save(); renderCalc(); refocus('[data-mir-model]'); break;
      case 'prob':
        var i = S.probs.indexOf(v); if (i > -1) S.probs.splice(i, 1); else S.probs.push(v);
        track('issue_toggle', { issue: v, on: i === -1 }); save(); renderCalc();
        if (v === OTHER && i === -1) refocus('[data-mir-other]'); else refocus('[data-act="prob"][data-v="' + (window.CSS && CSS.escape ? CSS.escape(v) : v) + '"]');
        break;
      case 'tier': S.tier = v; save(); renderCalc(); refocus('[data-act="tier"][data-v="' + v + '"]'); track('tier_pick', { model: S.model, tier: v }); break;
      case 'reset': var keepD = S.details; S = fresh(); S.details = keepD; save(); renderCalc(); refocus('[data-act="dev"]'); track('restart'); break;
      case 'request': request(b); break;
      case 'calc': go('calc'); break;
      case 'details': go('details'); break;
      case 'back': go(S.view === 'review' ? 'details' : 'calc'); break;
      case 'todetails': if (detailsValid()) go('review'); break;
      case 'restart': restart(); break;
    }
  });
  app.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-mir-model]')) {
      if (t.value === '__manual') { S.manual = true; S.model = null; S.spec = null; S.tier = null; save(); renderCalc(); refocus('[data-mir-typed]'); return; }
      S.model = t.value || null; S.spec = null; S.tier = null; S.typed = '';
      S.probs = S.probs.filter(function (p) { return isComplex(p) || p === OTHER || stdIssues().indexOf(p) > -1; });
      save(); renderCalc(); refocus('[data-mir-model]'); track('model', { model: S.model });
    } else if (t.matches('[data-confirm]')) {
      if (!$$('[data-confirm]', app).some(function (c) { return !c.checked; })) { var st = $('[data-mir-status]', app); if (st) st.textContent = ''; }
    } else if (t.matches('[data-d]')) { S.details[t.getAttribute('data-d')] = t.value; save(); }
  });
  app.addEventListener('input', function (e) {
    var t = e.target;
    if (t.matches('[data-mir-typed]')) {
      var had = hasModel(); S.typed = t.value; save();
      if (had !== hasModel()) { var pos = t.selectionStart; renderCalc(); var n = $('[data-mir-typed]', panel); if (n) { n.focus(); try { n.setSelectionRange(pos, pos); } catch (er) {} } }
      else renderResult();
    } else if (t.matches('[data-mir-other]')) { S.otherText = t.value; save(); }
    else if (t.matches('[data-d]')) { S.details[t.getAttribute('data-d')] = t.value; save(); }
  });
  app.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && S.view === 'details' && e.target.matches('input')) { e.preventDefault(); if (detailsValid()) go('review'); }
  });

  /* ---------- Submit: Shopify contact form via fetch ---------- */
  function ref() {
    var d = new Date(); var p = function (n) { return (n < 10 ? '0' : '') + n; };
    var chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'; var r = '';
    for (var i = 0; i < 4; i++) r += chars[Math.floor(Math.random() * chars.length)];
    return 'R-' + String(d.getFullYear()).slice(2) + p(d.getMonth() + 1) + p(d.getDate()) + '-' + r;
  }
  function summaryText(q) {
    return q.lines.map(function (l) {
      var price = l.v ? money2(l.v.price) : (l.kind === 'complex' ? 'diagnosis first' : 'price to confirm');
      var tier = l.tier && l.kind === 'std' ? ' (' + (tierInfo(l.tier).name || l.tier) + ')' : '';
      return '- ' + l.label + tier + ': ' + price + (l.kind === 'other' && l.note ? ' | "' + l.note + '"' : '');
    }).join('\n');
  }
  function fillHidden() {
    var q = computeQuote(); var id = ref();
    var totalTxt = q.priced ? money2(q.total) + ' CAD plus tax' + (q.allPriced ? '' : ' (plus items to confirm)') : (q.simple ? 'To confirm after inspection' : 'n/a (complex repair only)');
    var feeTxt = q.complex && DIAG_FEE ? money2(DIAG_FEE) + ' CAD diagnostic fee (waived if repair approved or not fixable)' : '';
    var confirms = $$('[data-confirm]', reviewEl).filter(function (c) { return c.checked; }).map(function (c) { return c.getAttribute('data-confirm'); });
    var fields = { 'Request': 'Mail-in repair request', 'Reference': id, 'Device': deviceName(), 'Repairs': summaryText(q), 'Priced repairs total': totalTxt };
    if (feeTxt) fields['Diagnostic fee'] = feeTxt;
    fields['Pricing'] = D.live ? 'Live prices' : 'Prices not live yet: confirm the price with the customer';
    fields['Customer confirmed'] = confirms.join('; ');
    var bodyTxt = 'Mail-in repair request ' + id + '\n\nDevice: ' + deviceName() + '\n\nRepairs:\n' + summaryText(q) +
      (q.disc ? '\nBundle discount: -' + money2(q.disc) : '') +
      '\nPriced repairs total: ' + totalTxt + (feeTxt ? '\nDiagnostic fee: ' + feeTxt : '') + '\nShipping: customer covers it' +
      '\n\nAbout the device:\n' + answers().map(function (a) { return '- ' + a[0] + ': ' + a[1]; }).join('\n') +
      '\n\nContact and return address:\n' + contactLines().join('\n') +
      '\n\nConfirmed:\n' + confirms.map(function (c) { return '- ' + c; }).join('\n');
    var box = $('[data-mir-hidden]', form); box.innerHTML = '';
    Object.keys(fields).forEach(function (k) { var inp = document.createElement('input'); inp.type = 'hidden'; inp.name = 'contact[' + k + ']'; inp.value = fields[k]; box.appendChild(inp); });
    $('[data-mir-body-field]', form).value = bodyTxt;
    return { id: id, q: q };
  }
  function doneHtml(id) {
    return '<div class="mir-done"><span class="mir-done__icon" aria-hidden="true">' + CHECK + '</span>' +
      '<h3 class="mir-step__title" tabindex="-1">Request received</h3><p class="mir-step__sub">We\'ll review it and email you next steps. Please don\'t ship your device until you get our approval email.</p>' +
      (id ? '<p class="mir-done__ref">Reference: <b>' + esc(id) + '</b></p>' : '') +
      '<button type="button" class="mir-btn mir-btn--ghost" data-act="restart">Start another request</button></div>';
  }
  function showDone(id) {
    store.del(KEY); S = fresh(); S.view = 'done';
    calcView.hidden = true; updateBar(); formcard.hidden = false;
    detailsEl.hidden = true; reviewEl.hidden = true;
    var d = document.createElement('div'); d.setAttribute('data-mir-donebox', ''); d.innerHTML = doneHtml(id); form.appendChild(d);
    var t = $('.mir-step__title', d); if (t) t.focus({ preventScroll: true });
    app.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }
  function restart() {
    store.del(KEY); S = fresh();
    if (postedEl) { var u = new URL(location.href); u.searchParams.delete('contact_posted'); u.hash = 'quote'; location.href = u.toString(); return; }
    var d = $('[data-mir-donebox]', app); if (d) d.remove();
    save(); render(false); app.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }
  if (form && reviewEl) form.addEventListener('submit', function (e) {
    e.preventDefault();
    var status = $('[data-mir-status]', form); status.textContent = '';
    if (!detailsValid()) { go('details'); detailsValid(); return; }
    var unchecked = $$('[data-confirm]', reviewEl).filter(function (c) { return !c.checked; })[0];
    if (unchecked) { status.textContent = 'Please tick all three boxes to submit.'; unchecked.focus(); return; }
    var info = fillHidden();
    var btn = $('[data-mir-submit]', form);
    btn.disabled = true; btn.textContent = 'Sending...';
    track('request_submit', { reference: info.id, priced: info.q.priced, complex: info.q.complex, items: info.q.lines.length });
    var native = function () { HTMLFormElement.prototype.submit.call(form); };
    fetch(form.getAttribute('action') || '/contact', { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' }, credentials: 'same-origin' })
      .then(function (r) { return r.text().then(function (txt) { return { r: r, txt: txt }; }); })
      .then(function (res) {
        var url = res.r.url || '';
        if (/\/challenge/.test(url)) { native(); return; } // spam check: let the browser show it
        if (res.r.ok && (/contact_posted=true/.test(url) || res.txt.indexOf('data-mir-posted') > -1)) { btn.disabled = false; btn.textContent = 'Submit repair request'; track('request_sent', { reference: info.id }); showDone(info.id); return; }
        btn.disabled = false; btn.textContent = 'Submit repair request';
        status.textContent = 'We couldn\'t send that. Check your details and try again.';
        track('request_error', { reference: info.id, status: res.r.status });
      })
      .catch(function () { native(); });
  });

  /* ---------- Boot ---------- */
  if (form) form.noValidate = true; // validation is handled step by step above
  track('app_view', { page: location.pathname, preset: presetModel || null });
  if (postedEl) {
    store.del(KEY); S = fresh(); S.view = 'done';
    calcView.hidden = true; if (formcard) formcard.hidden = false; updateBar();
  } else {
    if ($('[data-mir-errors]', app)) S.view = 'details';
    render(false);
  }
})();
